export const APP_NAME = 'doc_ychl';
export const BOOKHOSID = '057103';  //标准版057103 深圳075501
export const COPYRIGHT_COMPANY_NAME = '成都医云科技有限公司' //版权所有公司
export const HOSID = '3308000001';
export const TEE3 = 'v.diandianys.com';
/**
 * 基础参数
 * @type {{channel: string, format: string, oper: string, random: string, spid: string}}
 */
export const BASE_PARAMS = {
    'channel': '4',
    'format': 'JSON',
    'oper': '127.0.0.1',
    'random': '1234',
    'spid': '1001',
    version: '1.0.0'
}

/**
 * 主题色
 * @type {string}
 */
export const MAIN_COLOR = '#0893FF';

/**
 * 左侧背景色
 * @type {string}
 */
export const LEFT_BG = '#324157';

/**
 * 视频播放器控制按钮
 * @type {*[]}
 */
export const VIDEO_CONTROLS = [
    {
        icon: require('../assets/icon/jingyin.fw.png'),
        icon1: require('../assets/icon/quxiaojingyin.fw.png'),
        name: '静音',
        name1: '取消静音',
        default: 0
    },
    {
        icon: require('../assets/icon/guaduan.png'),
        name: '挂断',
        default: 0
    },
    {
        icon: require('../assets/icon/guanbi.fw.png'),
        icon1: require('../assets/icon/dakai.fw.png'),
        name: '关闭视频',
        name1: '打开视频',
        default: 0
    }
]
/**
 * 续方类型
 * @type {*[]}
 */
export const RENEWAL_TYPE = [
    {name: '本院续方', id: 'INSIDE'},
    {name: '外院续方', id: 'EXTERNAL'},
]

/**
 * 慢病续方-订单状态
 * @type {*[]}
 */
export const RENEWAL_ORDER_STATUS = [
    {id: 'APPLYING', name: '待续方', desc: '请耐心等待医生处理，医生可能会联系您。'},
    {id: 'CONTINUATION', name: '已续方'},
    {id: 'CANCEL', name: '已拒绝', desc: ''},
];

/**
 * 处方-订单状态
 * @type {*[]}
 */
export const RECIPE_ORDER_STATUS = [
    {id: 'ISSUE', name: '待审核', color: 'warn_font'},
    {id: 'WAIT_SIGN', name: '待签名', color: 'warn_font'},
    {id: 'REFUSE', name: '已拒绝', color: 'color_main'},
    {id: 'AUDIT', name: '审核通过', color: 'color_main'},
    {id: 'WAITTAKE', name: '待取药', color: 'color_main'},
    {id: 'WAITSHIP', name: '待取药', color: 'color_main'},
    {id: 'SHIPPING', name: '待取药', color: 'color_main'},
    {id: 'TAKING', name: '待取药', color: 'color_main'},
    {id: 'COMPLETE', name: '已完成', color: 'color_main'},
    {id: 'CANCEL', name: '已作废', color: 'color_main'},
    {id: 'RECALL', name: '已失效', color: 'color_main'},
];

/**
 * 网络诊间-门诊类别
 * @type {*[]}
 */
export const ONLINE_MZLB = [
    {value: '1', label: '专家门诊'},
    {value: '2', label: '普通门诊'}
]
/**
 * 网络诊间订单状态
 * @type {{"0": string, "3": string, "5": string}}
 */
export const ONLINE_DDZT = {
    '0': {name: '候诊中', icon: require('../assets/icon/online/候诊中.png')},
    '1': {name: '待候诊'},
    '3': {name: '已取消'},
    '5': {name: '已完成', icon: require('../assets/icon/online/订单已完成.png')}
}

/**
 * 网络诊间订单状态映射按钮
 * @type {{"0": string, "3": string, "5": string}}
 */
export const ONLINE_DDZT_BTN = {
    '0': [],
    '1': ['提醒进入诊间', '接诊'],
    '2': ['查看资料']
}

/**
 * 网络诊间订单状态按钮
 * @type {{"0": string, "3": string, "5": string}}
 */
export const ONLINE_BTN_MAP = {
    '提醒进入诊间': {type: 'app_btn_default'},
    '接诊': {type: 'app_btn_primary'},
    '查看资料': {type: 'app_btn_default'}
}
/**
 * 慢病续方-药品类型
 * @type {{"1": string, "2": string}}
 */
export const RENEWAL_CHUFANG_TYPE = {
    '1': '西药药品',
    '0': '中药药品'
}
/**
 * 会诊类型
 * @type {string[]}
 */
export const CONSULTATION_TYPE = [
    '名医会诊', '急会诊', '多科会诊', 'ICU会诊', '护理会诊'
];
/**
 * 会诊辅助诊断类型
 * @type {string[]}
 */
export const CONSULTATION_AUXILIARYDIAGNOSE = ['影像', '病理'];

/**
 * 婚姻状态
 * @type string[]
 */
export const MARITALSTATUS = ['未婚', '已婚', '离异', '未知'];
/**
 * 性别
 * @type {string[]}
 */
export const SEX = ['男', '女', '未知'];

/**
 * 会诊状态
 * @type {*[]}
 */
export const CONSULTATION_STATUS = [
    {name: '待处理', id: '1', service: 'smarthos.consult.group.waithandle.list'},
    {name: '待会诊', id: '2', service: 'smarthos.consult.group.waitvideo.list'},
    {name: '已完成', id: '3', service: 'smarthos.consult.group.comment.list'},
    {name: '已取消', id: '4', service: 'smarthos.consult.group.cancel.list'}
];

export const CONSULTATION_STATUS_DOC = [
    {name: '待会诊', id: '2', service: 'smarthos.consult.group.waitvideo.list'},
    {name: '已完成', id: '3', service: 'smarthos.consult.group.comment.list'},
    {name: '已取消', id: '4', service: 'smarthos.consult.group.cancel.list'}
];

/**
 * 远程会诊-doc-tabs
 * @type {*[]}
 */
export const CONSULTATION_DOC_STATUS = [
    {name: '发起的', id: '1', service: 'smarthos.consult.group.waithandle.list'},
    {name: '收到的', id: '2', service: 'smarthos.consult.group.waitvideo.list'},
    {name: '已完成', id: '3', service: 'smarthos.consult.group.comment.list'},
    {name: '已取消', id: '4', service: 'smarthos.consult.group.cancel.list'}
];
/**
 *
 * @type {{评价: {type: string}, 取消申请: {type: string}, 进入诊间: {type: string}, 补充资料: {type: string}}}
 */
export const CONSULTATION_BTN = {
    '取消申请': {type: 'danger'},
    '提交': {type: 'primary'},
    '进入诊间': {type: 'primary'},
    '确认补充': {type: 'primary'},
    '完成会诊': {type: 'primary'},
    '评价': {type: 'primary'},
    '提交会诊情况': {type: 'primary'},
    '申请转诊': {type: 'primary'},
    '提交修改': {type: 'primary'},
    '再次申请': {type: 'primary'}
};
/**
 * 转诊类型
 * @type {string[]}
 */
export const REFERRAL_TYPE = [{name: '门诊转诊', id: 'outpatient', value: 'OUT_PATIENT'}, {
    name: '住院转诊',
    id: 'hospitalization',
    value: 'IN_HOSPITAL'
}];

/**
 * 转诊详情按钮
 * @type {{取消申请: {type: string}, 提交: {type: string}}}
 */
export const REFERRAL_BTN = {
    '取消申请': {type: 'danger'},
    '提交': {type: 'primary'},
    '审核通过': {type: 'primary'},
    '门诊转诊安排': {type: 'primary'},
    '住院转诊安排': {type: 'primary'},
    '确认补充': {type: 'primary'},
    '再次申请': {type: 'primary'}
};
/**
 * 统计类型
 * @type {*[]}
 */
export const STATISTICS_TYPE = [
    {id: 'init', name: '发起的', value: 'DELIVER'},
    {id: 'accept', name: '接收到', value: 'RECEIVED'}
];

export const STATISTICS_TYPE_ = [
    {id: 'all', name: '全部', value: 'ALL'},
    {id: 'init', name: '发起的', value: 'DELIVER'},
    {id: 'accept', name: '接收到', value: 'RECEIVED'}
];

/**
 * 转诊状态 接受页面
 * @type {*[]}
 */
export const REFERRAL_STATUS = [
    {name: '待处理', id: ['2']},
    {name: '已完成', id: ['4']},
    {name: '已取消', id: ['-1', '-2']}
];

export const REFERRAL_STATUS_DOC = [
    {name: '已完成', id: ['4']},
];
/**
 * 转诊状态 申请页面
 * @type {*[]}
 */
export const REFERRAL_STATUS_INIT = [
    {name: '申请中', id: ['2']},
    {name: '已完成', id: ['4']},
    {name: '已取消', id: ['-1', '-2']}
];

/**
 * 推流地址(阿里云)
 * @type {string}
 */
export const PUSH_DOMAIN = 'vstream.diandianys.com';
/**
 * 推流域名（腾讯云）
 * @type {string}
 */
export const PUSH_TX_DOMAIN = '32457.livepush.myqcloud.com';


/**
 * 推流鉴权（阿里云）
 * @type {string}
 */
export const PUSH_KEY = '4mlRw7a018';

/**
 * 推流鉴权（腾讯云）
 * @type {string}
 */
export const PUSH_TX_KEY = 'be168ab32110efbddccd14c84aad9ddd';


/**
 * 播流地址
 * @type {string}
 */

export const PLAY_DOMAIN = 'vstreamb.diandianys.com';

/**
 * 播流地址(腾讯云)
 * @type {string}
 */

export const PLAY_TX_DOMAIN = 'player.limingwei.name';
/**
 * 播流鉴权
 * @type {string}
 */
export const PLAY_KEY = 'lEMook5xKB';//lEMook5xKB
/**
 * 有效时长
 * @type {number}
 */
export const TIME_LENGTH = 30000 * 60 * 1000;

/**
 * 药事服务-处方类型
 * */
export const ORDER_TYPE_LIST = [
    {value: 'WESTERN_RECIPE', label: '西药方'},
    {value: 'CHINESE_RECIPE', label: '中药方'},
    {value: 'DISPENSING_GRANULES', label: '配方颗粒方'}
]

/**
 * 外材订单-订单类型
 * */
export const PRODUCE_TYPE_LIST = [
    {value: 'MEDICAL_FOOD', label: '特医食品'},
    {value: 'MEDICAL_INSTRUMENT', label: '医疗器械'},
    {value: 'CHECK_INSPECT', label: '检验检查'}
]

/**
 * 药事服务-处方类型（简化版）
 * @type {{CHINESE_RECIPE: string, DISPENSING_GRANULES: string, WESTERN_RECIPE: string}}
 */
export const RECIPE_TYPE = ((list) => {
    let obj = {};
    list.forEach(item => {
        obj[item.value] = item.label;
    })
    return obj;
})(ORDER_TYPE_LIST);

export const VIDEO_COMMON_BTNS = [
    {name: '图片', icon: require('../assets/icon/video/图片.png')},
    // {name: '白板', icon: require('../assets/icon/video/白板.png')},
    {name: '桌面分享', icon: require('../assets/icon/video/桌面分享.png')},
    {name: '文件传输', icon: require('../assets/icon/video/文件传输.png')},
    {name: '邀请讨论', icon: require('../assets/icon/video/邀请.png')},
    {name: '病情资料', icon: require('../assets/icon/video/资料.png')},
    // {name: '窗口显示', icon: require('../assets/icon/video/窗口.png')},
    {name: '挂断', icon: require('../assets/icon/video/挂断.png')}
]
/**
 * 远程门诊$cache key
 * @type {string}
 */
export const YCMZ_CACHE_KEY = 'ycmzInfo';
